var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ResizeService } from './resize.service';
import { fromEvent } from 'rxjs';
import { SCREEN_SIZE } from '../../classes/enums';
var BrowserResizeService = /** @class */ (function (_super) {
    __extends(BrowserResizeService, _super);
    function BrowserResizeService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrowserResizeService.prototype.onResize = function () {
        return fromEvent(window, 'resize');
    };
    BrowserResizeService.prototype.getMediaQuerySize = function () {
        // Phone Only
        if (window.matchMedia('(max-width: 599px)').matches)
            return SCREEN_SIZE.MOBILE_ONLY;
        else if (window.matchMedia('(min-width: 1800px)').matches)
            return SCREEN_SIZE.BIG_DESKTOP_UP;
        else if (window.matchMedia('(min-width: 1200px)').matches)
            return SCREEN_SIZE.DESKTOP_UP;
        else if (window.matchMedia('(min-width: 900px)').matches)
            return SCREEN_SIZE.TABLET_LANDSCAPE_UP;
        else
            return SCREEN_SIZE.TABLET_PORTRAIT_UP;
    };
    return BrowserResizeService;
}(ResizeService));
export { BrowserResizeService };
